module.exports = {
          srcSet: __webpack_public_path__ + "2915f448fc67e53e14ce94ecbc11e46a-500.png"+" 500w",
          images:[ {path: __webpack_public_path__ + "2915f448fc67e53e14ce94ecbc11e46a-500.png",width: 500,height: 130}],
          src: __webpack_public_path__ + "2915f448fc67e53e14ce94ecbc11e46a-500.png",
          toString:function(){return __webpack_public_path__ + "2915f448fc67e53e14ce94ecbc11e46a-500.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAATklEQVR4nC3LMQpAUACA4e8YLuAAVgOTRFJKvclmoqxGOYJ72VxIr978fz9kaJFjRo8OJW5MaODFhwonxhQHBByoI1zwpOvCig17QkVEP2sVCorNv2ckAAAAAElFTkSuQmCC",
          width: 500,
          height: 130
        }